import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig";
import AOPPrev from "./AOPPrev";
import { AOPSwitzerlandAdmissionData } from "@/src/types/admissionOffice";

const emptyAdmissionState = (): AOPSwitzerlandAdmissionData => ({
  currentDate: "",
  fullName: "",
  nationality: "",
  course: "",
  userOffice: "01",
  whose_doc: "",
  title: "",
  dateOfBirth: "",
  passport_number: "",
  academicYear: "",
  duration: "",
  mediumOfInstruction: "",
  coursePrefix: "",
  body: [],
});

const AOPAdmissionLetterSwissLayout = () => {
  const [dataForGeneration, setDataForGeneration] = useState<AOPSwitzerlandAdmissionData>(emptyAdmissionState);
  const [bodyForPrev, setBodyForPrev] = useState<AOPSwitzerlandAdmissionData>(emptyAdmissionState);

  return (
    <div className="container admission-office-page">
      <AOPConfig
        dataForGeneration={dataForGeneration}
        setDataForGeneration={setDataForGeneration}
        setBodyForPrev={setBodyForPrev}
      />
      <AOPPrev bodyForPrev={bodyForPrev} />
    </div>
  );
};

export default AOPAdmissionLetterSwissLayout;
